import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Shield } from 'lucide-react';
import { AVAILABLE_ICONS, ICON_NAMES } from './icon-map';

interface IconSelectorProps {
  value: string;
  onChange: (icon: string) => void;
}

export function IconSelector({ value, onChange }: IconSelectorProps) {
  const [open, setOpen] = useState(false);
  const SelectedIcon = AVAILABLE_ICONS[value as keyof typeof AVAILABLE_ICONS] || Shield;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" className="w-full justify-start gap-2">
          <SelectedIcon className="h-4 w-4" />
          <span>{value || 'Select icon'}</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-2">
        <div className="grid grid-cols-6 gap-1">
          {ICON_NAMES.map((iconName) => {
            const Icon = AVAILABLE_ICONS[iconName];
            return (
              <button
                key={iconName}
                onClick={() => {
                  onChange(iconName);
                  setOpen(false);
                }}
                className={`p-2 rounded hover:bg-muted ${value === iconName ? 'bg-primary/10 text-primary' : ''}`}
                title={iconName}
              >
                <Icon className="h-4 w-4" />
              </button>
            );
          })}
        </div>
      </PopoverContent>
    </Popover>
  );
}
